import { Box, Button, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MAYA_COLORS } from '@root/Theme';

export const MainContainer = styled(Box)({
    backgroundColor: 'white',
    color: 'black',
    width: '100%',
    height: '92vh',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    paddingBottom: '32px',
});

export const ContentContainer = styled(Box)({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

export const StyledTypography = styled(Typography)({
    fontFamily: 'Work Sans',
});

export const StyledPaper = styled(Paper)({
    padding: '8px',
    elevation: '48px',
    border: `0.5px solid ${MAYA_COLORS.borderGray}`,
});

export const StyledButton = styled(Button)({
    backgroundColor: 'black',
    color: 'white',
    fontSize: '1.15rem',
    fontWeight: 600,
    fontFamily: 'Work Sans',
    textTransform: 'none',
    padding: '10px 32px',
    borderRadius: '8px',
    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.45)',
    '&:hover': {
        backgroundColor: '#333333',
        boxShadow: '0 8px 26px rgba(0, 0, 0, 0.6)',
    },
});

export const FooterText = styled(Typography)({
    color: 'grey.500',
    paddingBottom: '8px',
    textAlign: 'center',
});
